import { DeleteCreditCardPayload } from 'api/users/creditCards';
import { either } from 'fp-ts';
import { Either } from 'fp-ts/lib/Either';

export const optimisticallyRemoveCard: (
  deletedCard: DeleteCreditCardPayload,
) => (cache: CF.API.Users.ListCreditCardsResponse) => Either<never, CF.API.Users.ListCreditCardsResponse> = (deletedCard) => (cache) => {
  const filteredCards = cache.cards.filter((c) => c.id !== deletedCard.id);

  return either.right({
    ...cache,
    cards: filteredCards,
  });
};

export const getExpMonth = (month: string): string => {
  return `0${month}`.slice(-2);
};

export const getExpYear = (year: string): string => {
  return year.slice(-2);
};

export const formatNumberType = (value: string): string => {
  return value.replace(
    /\D/g,
    '', // allow only numbers
  );
};
